/* Progressive disclosure only. All reviews remain readable without JavaScript. */
(() => {
  if (window.__tshReviewLibrary) return;
  window.__tshReviewLibrary = true;
  const initialize = (scope = document) => {
    const roots = [...scope.querySelectorAll('[data-review-library]')];
    if (scope.matches?.('[data-review-library]')) roots.unshift(scope);
    roots.forEach(root => {
      if (root.dataset.reviewReady) return;
      const cards = [...root.querySelectorAll('[data-written-review]')];
      const button = root.querySelector('[data-review-toggle]');
      const status = root.querySelector('[data-review-status]');
      if (!button) return;
      root.dataset.reviewReady = 'true';
      const initial = Math.max(1, Number(root.dataset.initial) || 8);
      // Do not hide merchant blocks while editing.
      if (window.Shopify?.designMode || cards.length <= initial) return;
      let expanded = false;
      const update = (announce = false) => {
        cards.forEach((card, index) => { card.hidden = !expanded && index >= initial; });
        button.hidden = false;
        button.setAttribute('aria-expanded', String(expanded));
        button.textContent = expanded ? root.dataset.less : root.dataset.more;
        if (announce && status) status.textContent = expanded ? root.dataset.expandedMessage : root.dataset.collapsedMessage;
      };
      button.addEventListener('click', () => {
        expanded = !expanded;
        update(true);
        if (!expanded) {
          button.focus({ preventScroll: true });
          button.scrollIntoView({ block: 'nearest', behavior: 'instant' });
        }
      });
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
